import useMediation from "./useMediation";

export default useMediation;